import store from '@/store/store';
import eventListenerService from '@/modules/common/services/eventListenerService';

const moduleStore = {
    state: {
        features: [],
        forceFeature: null
    },
    mutations: {
        setFeatures(state, {features}) {
            state.features = features
            if (features && features.length > 0) {
                eventListenerService.emit('featureFlagsLoaded');
            }
        },
        addForceFeature(state, feature){
          state.forceFeature = feature
      }
    },
    getters: {
      hasFeature: state => fName => state.features.includes(fName) || fName === state.forceFeature,
      featureFlagsLoaded: state => state.features.length > 0,
    }
}

// this directive is not reactive, if you need reactivity mechanism use the component
// use this only if features array is already set
const createDirective = (Vue) => {
    Vue.directive('feature', {
        inserted(el, binding, vnode, old) {
            const featureName = binding.value || binding.arg
            if (!featureName) return
            if (!vnode.context.$hasFeature(featureName)) {
                vnode.elm.parentElement.removeChild(vnode.elm)
            }
        }
    })
}

const createComponent = (Vue) => {
    Vue.component('feature-wrapper', {
        props: ['name'],
        render: function (createElement) {
            if (!this.$store.getters.hasFeature(this.name)) return ""

            return createElement(
                'div',   // tag name
                {attrs: { class: 'feature-wrapper'}},
                this.$slots.default // array of children
            )
          }
    })
}

const addToVueInstance = (Vue) => {
    Vue.prototype.$hasFeature = function (name) {
        return store.getters.hasFeature(name);
    };

    Vue.prototype.$featureFlagsLoaded = function () {
        return store.getters.featureFlagsLoaded;
    };
}

const defaultOptions = {
    directive: true,
    component: true,
    instance: true
}

const isValidOptions = (options) => {
    if (!options.store) return false

    return true
}

const errorMessage = "Features plugin: You must provide store in options.";

const FeaturesPlugin = {
    // you can pass the features names in array in options
    // or commit them manually to the store
    install(Vue, options) {

        options = Object.assign(defaultOptions, options)
        if (!isValidOptions(options)) throw new Error(errorMessage);

        const {store, features} = options
        store.registerModule('Features', moduleStore)

        if (features) store.commit({type: 'setFeatures', features})

        options.directive && createDirective(Vue)
        options.component && createComponent(Vue)
        options.instance && addToVueInstance(Vue)
    }
};

export default FeaturesPlugin;
